export default function ForgotPassword() {
  return (
    <div>ForgotPassword</div>
  )
}
